var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"player",staticClass:"rounded",attrs:{"src":_vm.embedLink,"width":_vm.videoWidth,"height":_vm.iframeHeight,"allow":"autoplay","frameborder":"0","allowscriptaccess":"always"}})
}
var staticRenderFns = []

export { render, staticRenderFns }